import React, { Fragment, useState } from "react";

import FormGrouping from "../../../components/forms/FormGrouping";
import CheckboxGroupService from "../../../services/form/CheckboxGroupService";

import "./FormExportarExcel.scss";

export default function FormExportarExcel({ result, caracteristicasDefault }) {
  const [consulta, setConsulta] = useState("");
  const [selectedIdentificacoes, setIdentificacoes] = useState([]);
  const [selectedGenealogia, setSelectedGenealogia] = useState([]);
  const [selectedReguaDeps, setSelectedReguaDeps] = useState([]);
  const [selectedNumeroDeFilhos, setSelectedNumeroDeFilhos] = useState([]);
  const [selectedPeso, setSelectedPeso] = useState([]);
  const [selectedDeps, setSelectedDeps] = useState([]);

  const identificacoes = [
    "Série",
    "Raça",
    "Variedade",
    "Situação",
    "RGN",
    "Categoria",
    "Sexo",
    "NFA",
    "RGD",
    "Data de Nascimento",
    "Nome",
    "NFO",
  ];
  const genealogia = ["Pai", "Avô Paterno", "Mãe", "Avô Materno"];
  const reguaDeps = ["DEP", "Percentil", "Acurácia"];
  const numeroDeFilhos = [
    "NF3P",
    "NFSTAY",
    "NF450",
    "NFUS",
    "NFSAMS",
    "NN120",
    "NF120",
    "NR210",
    "NR450",
    "NRUS",
    "NRN120",
    "NR120",
  ];
  const peso = ["P120", "P210", "P365", "P450", "PE365", "PE450"];

  const handleIdentificacao = (option) => {
    const newIdentificacoes = CheckboxGroupService.getSelectedUpdated(
      selectedIdentificacoes,
      option
    );
    setIdentificacoes(newIdentificacoes);
    setConsulta({ ...consulta, identificacoes: selectedIdentificacoes });
  };

  const handleGenealogia = (option) => {
    const newGenealogia = CheckboxGroupService.getSelectedUpdated(
      selectedGenealogia,
      option
    );
    setSelectedGenealogia(newGenealogia);
    setConsulta({ ...consulta, deps: selectedGenealogia });
  };

  const handleReguaDeps = (option) => {
    const newReguaDeps = CheckboxGroupService.getSelectedUpdated(
      selectedReguaDeps,
      option
    );
    setSelectedReguaDeps(newReguaDeps);
    setConsulta({ ...consulta, deps: selectedReguaDeps });
  };

  const handleNumeroDeFilhos = (option) => {
    const newNumeroDeFilhos = CheckboxGroupService.getSelectedUpdated(
      selectedNumeroDeFilhos,
      option
    );
    setSelectedNumeroDeFilhos(newNumeroDeFilhos);
    setConsulta({ ...consulta, deps: selectedNumeroDeFilhos });
  };

  const handlePeso = (option) => {
    const newPeso = CheckboxGroupService.getSelectedUpdated(
      selectedPeso,
      option
    );
    setSelectedPeso(newPeso);
    setConsulta({ ...consulta, deps: selectedPeso });
  };

  const handleDEPS = (option) => {
    const newDeps = CheckboxGroupService.getSelectedUpdated(
      selectedDeps,
      option,
      "caracteristicaId"
    );
    setSelectedDeps(newDeps);
    setConsulta({ ...consulta, deps: selectedDeps });
  };

  const handleSubmit = () => {};

  const selecioneTodos = () => {
    for (let i of identificacoes) handleIdentificacao(i);
    let checkboxes = document.getElementsByTagName("input");
    for (var i = 0, n = checkboxes.length; i < n; i++)
      checkboxes[i].checked = true;
  };

  const desmarcarTodos = () => {
    for (let i of identificacoes) handleIdentificacao(i);
    let checkboxes = document.getElementsByTagName("input");
    for (var i = 0, n = checkboxes.length; i < n; i++)
      checkboxes[i].checked = false;
  };

  const getAsOptions = (options, handleFunction, propertyToShow) => {
    return (Array.isArray(options) ? options : []).map((option, i) => {
      return (
        <div className="d-flex align-items-center mb-3">
          <div
            className="table-remove__input-container"
            key={i}
            style={{ width: 30 }}
          >
            <input
              className="table-remove__input"
              type="checkbox"
              id={i}
              key={i}
              onChange={(e) => handleFunction(option)}
            ></input>
            <span className="table-remove__input-custom"></span>
          </div>
          <label className="roboto fs-18px text-light-soft">
            {propertyToShow ? option[propertyToShow] : option}
          </label>
        </div>
      );
    });
  };

  return (
    <Fragment>
      {result && result.length === 0 && (
        <h3 className="mt-4">Faça a consulta na aba filtro</h3>
      )}

      {result && result.length > 0 && (
        <Fragment>
          <div className="d-flex justify-content-end mt-3">
            <button
              className="global-btn-info shadow-none justify-content-center"
              onClick={desmarcarTodos}
              style={{ marginRight: 20, width: 197 }}
            >
              Desmarcar todos
            </button>
            <button
              className="global-btn-info shadow-none justify-content-center"
              onClick={selecioneTodos}
              style={{ width: 197 }}
            >
              Selecione todos
            </button>
          </div>

          <FormGrouping title="Identificação" borderBottomWidth={125}>
            <div className="excel-export-grid mt-4">
              {getAsOptions(identificacoes, handleIdentificacao)}
            </div>
          </FormGrouping>
          <FormGrouping title="Genealogia" borderBottomWidth={108}>
            <div className="excel-export-grid mt-4">
              {getAsOptions(genealogia, handleGenealogia)}
            </div>
          </FormGrouping>
          <FormGrouping title="DEPS" borderBottomWidth={51}>
            <div className="excel-export-grid mt-4">
              {getAsOptions(
                caracteristicasDefault,
                handleDEPS,
                "caracteristicaDescricao"
              )}
            </div>
          </FormGrouping>
          <FormGrouping
            title="Personalizar Régua de DEPS"
            borderBottomWidth={108}
          >
            <div className="excel-export-grid mt-4">
              {getAsOptions(reguaDeps, handleReguaDeps)}
            </div>
          </FormGrouping>
          <FormGrouping
            title="Número de Filhos / Rebanhos"
            borderBottomWidth={125}
          >
            <div className="excel-export-grid mt-4">
              {getAsOptions(numeroDeFilhos, handleNumeroDeFilhos)}
            </div>
          </FormGrouping>
          <FormGrouping title="Peso Padronizado" borderBottomWidth={125}>
            <div className="excel-export-grid mt-4">
              {getAsOptions(peso, handlePeso)}
            </div>
          </FormGrouping>

          <div className="btn-container">
            <a href="/submodulos/2" className="global-btn-info shadow-none">
              Voltar
            </a>
            <button
              className="global-btn-info shadow-none fs-5 justify-content-center"
              onClick={handleSubmit}
              style={{ width: 258, height: 67 }}
            >
              Exportar
            </button>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
}
